module.exports = __webpack_public_path__ + "static/media/stripe.1b386abf.svg";